export default "__VITE_PUBLIC_ASSET__6ab5e714__"